import {MainArea} from './MainArea';
export default MainArea;
